/* Shared storefront core. Feature code is loaded by theme-loader.js. */
function btyAddMultiProductToCart() {}
function btyAddToCart() {}
function btyAddToCartButtonHtml() {}
function btyAgreeToTerms() {}
function btyBackInStockButtons() {}
function btyCartItemCount() {}
function btyCheckInventoryOnLoad() {}
function btyFeaturedProductSlider() {}
function btyFetchCart() {}
function btyFetchConfig() {}
function btyFormatPrice() {}
function btyGetProductPurchasePrice() {}
function btyMinicartRecommendations() {}
function btyOpenActiveCart() {}
function btyPickupAvailability() {}
function btyPickupAvailabilityInit() {}
function btyPriceHtml() {}
function btyProductInventory() {}
function btyProductPopup() {}
function btyProductPurchaseControls() {}
function btyProductShare() {}
function btyProductTabs() {}
function btyProductVariants() {}
function btyQuantityButton() {}
function btyQuickAdd() {}
function btyQuickSearch() {}
function btyQuickView() {}
function btyQuickViewVariants() {}
function btyRecipientForm() {}
function btySelectedVariant() {}
function btyShortDescription() {}
function btySideCart() {}
function btySideCartPopupOuter() {}
function btySplitSlider() {}
function btySwatch() {}
function btySyncMainVariantFromSticky() {}
function btySyncProductPurchasePrice() {}
function btyUpdateAddToCartTotals() {}
function btyUpdateBackInStockButton() {}
function btyUpdateDiscountSideCartItem() {}
function btyUpdateProductQuantity() {}
function btyUpdateProgressBarCart() {}
function btyUpdateStickyPurchaseControls() {}
function btyUpdateStockStatus() {}
function btyUpdateStockStatusProduct() {}
function btyUpdateStorage() {}
function btyUpdateVariantPrice() {}
function btyValidateEmail() {}
function btyVariantsPopup() {}
function btyWatchProductPurchasePrice() {}
function setupThumbProgress() {}

// Animation for accordion.
class btyAccordion {
	constructor( el, toggle = 'summary', view = '.details-content' ) {
		const accordion = this;

		accordion.el      = el;
		accordion.summary = el.querySelector( toggle );
		accordion.content = el.querySelector( view );

		accordion.animation   = null;
		accordion.isClosing   = false;
		accordion.isExpanding = false;

		if ( ! accordion.content ) {
			return;
		}

		accordion.summary.addEventListener(
			'click',
			function( e ) {
				accordion.onClick( e );
			}
		);
	}

	onClick(e) {
		e.preventDefault();
		const accordion = this;

		accordion.el.style.overflow = 'hidden';

		let aria = accordion.summary.getAttribute( 'aria-expanded' );

		if ( accordion.isClosing || ! accordion.el.open ) {
			accordion.open();

			if ( aria ) {
				accordion.summary.setAttribute( 'aria-expanded', 'true' );
			}
		} else if ( accordion.isExpanding || accordion.el.open ) {
			accordion.shrink();

			if ( aria ) {
				accordion.summary.setAttribute( 'aria-expanded', 'false' );
			}
		}
	}

	shrink() {
		const accordion = this;

		accordion.isClosing = true;

		let startHeight = accordion.el.offsetHeight + 'px',
			endHeight   = accordion.summary.offsetHeight + 'px';

		if ( accordion.animation ) {
			accordion.animation.cancel();
		}

		accordion.animation = accordion.el.animate(
			{
				height: [startHeight, endHeight]
			},
			{
				duration: 200,
				easing: 'ease-out'
			}
		);

		accordion.animation.onfinish = function() {
			accordion.onAnimationFinish( false );
		}

		accordion.animation.oncancel = function() {
			accordion.isClosing = false;
		}
	}

	open() {
		const accordion = this;

		accordion.el.style.height = accordion.el.offsetHeight + 'px';
		accordion.el.open         = true;

		window.requestAnimationFrame(
			function() {
				accordion.expand();
			}
		);
	}

	expand() {
		const accordion = this;

		accordion.isExpanding = true;

		let startHeight = accordion.el.offsetHeight + 'px',
			endHeight   = ( accordion.summary.offsetHeight + accordion.content.offsetHeight ) + 'px';

		if (accordion.animation) {
			accordion.animation.cancel();
		}

		accordion.animation = accordion.el.animate(
			{
				height: [startHeight, endHeight]
			},
			{
				duration: 200,
				easing: 'ease-out'
			}
		);

		accordion.animation.onfinish = function() {
			accordion.onAnimationFinish( true );
		}

		accordion.animation.oncancel = function() {
			accordion.isExpanding = false;
		}
	}

	onAnimationFinish(open) {
		const accordion = this;

		accordion.el.open     = open;
		accordion.animation   = null;
		accordion.isClosing   = false;
		accordion.isExpanding = false;

		accordion.el.removeAttribute( 'style' );
	}
}

function btyAccordionHandle( doc = document ) {
	let details = doc.querySelectorAll( 'details' );
	if ( ! details.length ) {
		return;
	}

	details.forEach(
		function( el ) {
			// No apply effect for motion reduce node.
			if ( el.hasAttribute( 'data-motion-reduce' ) ) {
				return;
			}

			new btyAccordion( el );
		}
	);
}

// Accordion hover.
function btyAccordionHover( doc = document ) {
	let menus = doc.querySelectorAll( '.menu-map.faq-accordion' );

	if ( ! menus.length ) {
		return;
	}

	menus.forEach(
		function( el ) {
			let section   = el.closest( '.shopify-section' ),
				id        = el.getAttribute( 'data-id' ),
				container = section ? section.querySelectorAll( '.content-map[data-id="' + id + '"]' ) : [];

			el.addEventListener(
				'mouseenter',
				function() {
					if ( window.matchMedia( '(max-width: 991px)' ).matches || window.matchMedia( '(hover: none)' ).matches ) {
						return;
					}

					if ( container.length ) {
						container.forEach(
							function( con ) {
								let sibs = btySiblings( con );
								if ( sibs.length ) {
									sibs.forEach(
										function( sib ) {
											sib.classList.remove( 'active' );
										}
									);
								}

								con.classList.add( 'active' );
							}
						);
					}
				}
			);
		}
	);
}

// Footer accordion.
function btyFooterAccordion( doc = document ) {
	let headings = doc.querySelectorAll( '.ft-block-heading' );
	if ( ! headings.length ) {
		return;
	}

	headings.forEach(
		function ( el ) {
			let block = el.parentNode.querySelector( '.ft-block-content' );
			if ( ! block ) {
				return;
			}

			if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
				el.parentNode.classList.remove( 'open' );
				block.removeAttribute( 'style' );

				return;
			}

			el.onclick = function () {
				if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
					return;
				}

				if ( 'none' === window.getComputedStyle( block ).display ) {
					btySlideDown( block );
					el.parentNode.classList.add( 'open' );
				} else {
					btySlideUp( block );
					el.parentNode.classList.remove( 'open' );
				}
			}
		}
	);
}

// Add class to style footer menu css.
function btyAddElementClass() {
	let elements = document.querySelectorAll('.ft-block-item.ft-block-menu');

	if ( !elements.length ) {
		return;
	}

	let lastElement = elements[elements.length - 1];

	elements[0].classList.add('first', 'open');
	lastElement.classList.add('last');

	if (elements.length === 1) {
		elements[0].classList.remove('first', 'last');
		elements[0].classList.add('has-radius');
	}
}

// Scroll in animation logic.
function btyIntersection( elements, observer ) {
	const offscreen = 'scroll-trigger-offscreen';

	elements.forEach(
		( el, index ) => {
			if ( el.isIntersecting ) {
				const target = el.target;

				if ( target.classList.contains( offscreen ) ) {
					target.classList.remove( offscreen );

					target.setAttribute( 'style', '--animation-order: ' + index + ';' );
				}

				observer.unobserve( target );
			} else {
				el.target.classList.add( offscreen );
			}
		}
	);
}

// Scroll trigger.
function btyScrollAnimationTrigger( doc = document, designMode = false ) {
	const selectors = Array.from( doc.getElementsByClassName( 'scroll-trigger' ) );
	if ( ! selectors.length ) {
		return;
	}

	if ( designMode ) {
		selectors.forEach(
			( el ) => {
				el.classList.add( 'scroll-trigger-design-mode' );
			}
		);

		return;
	}

	const observer = new IntersectionObserver(
		btyIntersection,
		{
			rootMargin: '0px 0px -20px 0px',
		}
	);

	selectors.forEach( ( el ) => observer.observe( el ) );
}

class ArticleImageOverlay extends HTMLElement {
	constructor() {
		super();
		this.applyStylesAndReorder = this.applyStylesAndReorder.bind(this);
	}

	connectedCallback() {
		this.applyStylesAndReorder();

		window.addEventListener('resize', this.applyStylesAndReorder);
		document.addEventListener('shopify:section:load', this.applyStylesAndReorder);
		document.addEventListener('shopify:section:select', this.applyStylesAndReorder);
		document.addEventListener('shopify:block:select', this.applyStylesAndReorder);
	}

	applyStylesAndReorder() {
		let header          	= document.querySelector('.header.transparent-header'),
			breadcrumb          = document.querySelector('.breadcrumb-section'),
			breadcrumbScrolling = document.querySelector('.breadcrumb-section .scrolling'),
			articleImage        = document.querySelector('.blog-single-section .cover-image'),
			isArticleTemplate   = document.body.classList.contains('template-article');

		// If there's no article image, remove applied styles
		if (!articleImage) {
			document.body.classList.remove('has-image-cover');

			if (breadcrumb) {
				breadcrumb.classList.remove('transparent');
				breadcrumb.style.top = ''; // Reset to default
			}
			return;
		} else {
			document.body.classList.add('has-image-cover');
		}

		if (breadcrumb && articleImage && isArticleTemplate) {
			breadcrumb.classList.remove('transparent');
			breadcrumb.style.top = '';
		}
	}
}

// Define custom element with a proper name
customElements.define('article-image', ArticleImageOverlay);

class BreadcrumbOverlay extends HTMLElement {
	constructor() {
		super();
		this.applyStylesAndReorder = this.applyStylesAndReorder.bind(this);
	}

	connectedCallback() {
		this.applyStylesAndReorder();

		window.addEventListener('resize', this.applyStylesAndReorder);
		document.addEventListener('shopify:section:load', this.applyStylesAndReorder);
		document.addEventListener('shopify:section:select', this.applyStylesAndReorder);
		document.addEventListener('shopify:block:select', this.applyStylesAndReorder);
	}

	disconnectedCallback() {
		window.removeEventListener('resize', this.applyStylesAndReorder);
		document.removeEventListener('shopify:section:load', this.applyStylesAndReorder);
		document.removeEventListener('shopify:section:select', this.applyStylesAndReorder);
		document.removeEventListener('shopify:block:select', this.applyStylesAndReorder);
	}

	applyStylesAndReorder() {
		let header            = document.querySelector('.header.transparent-header'),
			breadcrumbWrapper = document.querySelector('.breadcrumb-section .section-wrapper');

		if (!header || !breadcrumbWrapper) {
			return;
		}

		if (window.innerWidth > 1) {
			let headerHeight = header.offsetHeight;
			breadcrumbWrapper.style.paddingTop = headerHeight + 'px';
		} else {
			breadcrumbWrapper.style.paddingTop = null;
		}
	}
}

// Define custom element with a proper name
customElements.define('header-breadcrumb-overlay', BreadcrumbOverlay);

document.addEventListener('click', e => {
	const trigger = e.target.closest('.has-popup');
	if (!trigger) return;

	e.preventDefault();

	const sourcePopup = trigger.nextElementSibling;
	if (!sourcePopup || !sourcePopup.classList.contains('popup')) return;

	closeGlobalPopup();

	const overlay = document.createElement('div');
	overlay.className = 'global-popup-overlay';

	const popup = document.createElement('div');
	popup.className = 'global-popup';
	popup.innerHTML = sourcePopup.innerHTML;

	const closeBtn = document.createElement('button');
	closeBtn.className = 'global-popup-close';
	closeBtn.type = 'button';
	closeBtn.innerHTML = '×';

	closeBtn.addEventListener('click', closeGlobalPopup);
	overlay.addEventListener('click', ev => {
		if (ev.target === overlay) closeGlobalPopup();
	});

	popup.appendChild(closeBtn);
	overlay.appendChild(popup);
	document.body.appendChild(overlay);
	document.body.classList.add('popup-open');

	requestAnimationFrame(() => {
		document.dispatchEvent(new Event('scroll'));
		window.dispatchEvent(new Event('resize'));
	});
});

function closeGlobalPopup() {
	const overlay = document.querySelector('.global-popup-overlay');
	if (overlay) overlay.remove();
	document.body.classList.remove('popup-open');
}

document.addEventListener('keydown', e => {
	if (e.key === 'Escape') closeGlobalPopup();
});

class BtyAccordionDetails extends HTMLElement {
	constructor() {
		super();
		this.handlePointerDown = this.handlePointerDown.bind(this);
		this.handleKeydown = this.handleKeydown.bind(this);
		this.handleContextMenu = this.handleContextMenu.bind(this);

		this._suppressBlurCloseUntil = 0; // guard for right-click & context menu
	}

	connectedCallback() {
		this.detailsElements = this.querySelectorAll("details");
			if (!this.detailsElements.length) return;

			this.detailsElements.forEach((details) => {
				details.addEventListener("toggle", () => {
				const sum = details.querySelector(":scope > summary");
				if (sum) sum.setAttribute("aria-expanded", details.hasAttribute("open") ? "true" : "false");
				this.closeOthers(details);
			});
			const sum = details.querySelector(":scope > summary");
			if (sum && !sum.hasAttribute("aria-expanded")) {
			sum.setAttribute("aria-expanded", details.hasAttribute("open") ? "true" : "false");
			}
		});

		// Close on primary-button click outside (NOT right/middle)
		document.addEventListener("pointerdown", this.handlePointerDown, true);

		// Esc to close deepest open
		document.addEventListener("keydown", this.handleKeydown, true);

		// Mark contextmenu (right-click) inside to avoid closing
		this.addEventListener("contextmenu", this.handleContextMenu, true);
	}

	disconnectedCallback() {
		document.removeEventListener("pointerdown", this.handlePointerDown, true);
		document.removeEventListener("keydown", this.handleKeydown, true);
		this.removeEventListener("contextmenu", this.handleContextMenu, true);
	}

	closeOthers(openedDetails) {
		this.detailsElements.forEach((details) => {
			if (details !== openedDetails) {
				details.removeAttribute("open");
				details.querySelector(":scope > summary")?.setAttribute("aria-expanded", "false");
			}
		});
	}

	// Only close on primary-button click outside this component
	handlePointerDown(event) {
		if (event.button !== 0) return; // ignore right/middle clicks
		if (this.contains(event.target)) return;

		this.closeAll();
	}

	handleKeydown(event) {
		// ESC: đóng panel đang mở sâu nhất
		if (event.key === "Escape" || event.key === "Esc") {
			const openPanels = this.querySelectorAll("details[open]");
			// Nếu bên trong component có focus hoặc đang có panel mở
			if (!openPanels.length && !this.contains(document.activeElement)) return;

			const deepest = openPanels[openPanels.length - 1];
			if (deepest) {
				event.preventDefault();
				deepest.removeAttribute("open");
				const sum = deepest.querySelector(":scope > summary");
				sum?.setAttribute("aria-expanded", "false");
				sum?.focus();
				event.stopPropagation();
			}
			return;
		}

		// TAB: nếu đang có panel mở mà focus NHẢY RA KHỎI panel → đóng
		if (event.key === "Tab") {
			const openDetails = this.querySelector("details[open]");
			if (!openDetails) {
				return; // không có cái nào mở thì thôi
			}

			// Sau khi browser move focus xong mới kiểm tra
			requestAnimationFrame(() => {
				const root   = this.getRootNode?.() || document;
				const active = root.activeElement || document.activeElement;

				// Nếu focus mới vẫn nằm trong panel đang mở → giữ nguyên
				if (active && openDetails.contains(active)) {
					return;
				}

				// Nếu tới đây: focus đã ra ngoài panel (VD: sang menu khác / icon khác) → đóng
				this.closeAll();
			});
		}
	}

	handleContextMenu(e) {
		// If right-click happens inside the component, suppress blur-closing briefly
		if (this.contains(e.target)) {
			// suppress for a short window to ride out focus/blur churn from context menu
			this._suppressBlurCloseUntil = performance.now() + 400; // ms
		}
	}

	closeAll() {
		this.detailsElements.forEach((details) => {
			details.removeAttribute("open");
			details.querySelector(":scope > summary")?.setAttribute("aria-expanded", "false");
		});
	}
}

customElements.define('bty-accordion-details', BtyAccordionDetails);

function btyHeaderSticky() {
	let header = document.querySelector( '.header.is-sticky' );
	if ( ! header ) {
		return;
	}

	let doc            = document.documentElement,
		top            = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
		regular        = header.dataset.colorScheme || '',
		transparent    = header.dataset.transparentScheme || '',
		hasTransparent = header.dataset.hasTransparent === 'true'
		threshold      = header.offsetHeight || 1,
		atTop          = top <= threshold;

	// Clean any prior color classes, then apply only what's allowed
	header.classList.remove(regular, transparent);
	if (hasTransparent && atTop) {
		header.classList.add(transparent);
	} else {
		header.classList.add(regular);
	}

	// Your existing solid state after scroll
	header.classList.toggle('solid-sticky', !atTop);
	header.classList.toggle('is-scrolled', !atTop);

	const headerSection = header.closest( '.header-section' );
	if ( headerSection ) {
		headerSection.classList.toggle( 'header-is-scrolled', !atTop );
		headerSection.style.setProperty(
			'--sticky-header-hidden-top',
			`${ -( header.offsetHeight + 1 ) }px`
		);
	}
}







class PopupHandler extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const dots      = this.querySelector( '.dot' );
		const itemInner = this.querySelector( '.item-inner' );
		const body      = document.body;

		if (!dots || !itemInner) return;

		dots.addEventListener('click', (e) => {
			e.stopPropagation();
			body.classList.add( 'popup-map' );
			itemInner.classList.add( 'show-inner' );
		});

		itemInner.addEventListener('click', (e) => {
			e.stopPropagation();
		});

		document.addEventListener('click', () => {
			body.classList.remove( 'popup-map' );
			itemInner.classList.remove( 'show-inner' );
		});
	}
}

customElements.define( 'popup-handler', PopupHandler );

function btyToggleNavMenu ( doc = document ) {
	let selectors = doc.querySelectorAll( '.header-navigation .menu-item .menu-toggle' );

	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function ( el ) {
			let parent = el.parentNode;

			el.onclick = function() {
				parent.classList.toggle( 'open' );
			}

			document.addEventListener(
				'click',
				(event) => {
					if ( ! parent.contains( event.target ) ) {
						parent.classList.remove( 'open' );
					}
				}
			);
		}
	);
}
class btfMultimediaCollage extends HTMLElement {

	constructor() {
		super();
		this.observers = [];
	}

	connectedCallback() {
		this.init();

		this._onSectionLoad = () => {
			this.destroy();
			this.init();
		};

		document.addEventListener(
			'shopify:section:load',
			this._onSectionLoad
		);
	}

	disconnectedCallback() {
		document.removeEventListener(
			'shopify:section:load',
			this._onSectionLoad
		);

		this.destroy();
	}

	destroy() {
		this.observers.forEach(o => o.disconnect());
		this.observers = [];
	}

	init() {

		const items = this.querySelectorAll('.video-item');

		items.forEach(item => {

			const isAutoplay =
				item.dataset.autoplay === "true";

			const playBtn =
				item.querySelector('.play-video');

			const localVideo =
				item.querySelector('.js-local-video');

			const iframe =
				item.querySelector('.js-video-embed');

			const removeOverlay = () => {
				item.querySelector('.video-image-wrapper')?.remove();
				playBtn?.remove();
			};

			/* =====================
					CLICK PLAY (MP4)
			===================== */
			if (playBtn && localVideo) {

				playBtn.addEventListener('click', () => {

					const source =
						localVideo.querySelector('source');

					if (source?.dataset.src && !source.src) {
						source.src = source.dataset.src;
						localVideo.load();
					}

					localVideo.muted = false;
					localVideo.play().catch(()=>{});

					removeOverlay();

				}, { once:true });
			}

			/* =====================
					AUTOPLAY
			===================== */
			if (isAutoplay) {

				const observer =
					new IntersectionObserver(entries => {

						entries.forEach(entry => {

							if (!entry.isIntersecting) return;

							/* MP4 */
							if (localVideo) {

								const source =
									localVideo.querySelector('source');

								if (source?.dataset.src && !source.src) {
									source.src = source.dataset.src;
									localVideo.load();
								}

								localVideo.muted = true;
								localVideo.play().catch(()=>{});

								removeOverlay();
							}

							/* Youtube / Vimeo */
							if (iframe &&
									iframe.dataset.src &&
									!iframe.src) {

								iframe.src = iframe.dataset.src;
								removeOverlay();
							}

						});

					}, { threshold: 0.4 });

				observer.observe(item);
				this.observers.push(observer);
			}

		});
	}
}

customElements.define(
	'btf-multimedia-collage',
	btfMultimediaCollage
);











class ScrollingRow extends HTMLElement {
	constructor() {
		super();
		this.onScroll = this.onScroll.bind(this);
	}

	connectedCallback() {
		this.items = this.querySelectorAll('.full-services__item');
		if (!this.items.length) return;

		this.onScroll();
		window.addEventListener('scroll', this.onScroll, { passive: true });
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScroll);
	}

	onScroll() {
		const viewportHeight = window.innerHeight;

		this.items.forEach((item, index) => {
			if (index === this.items.length - 1) return;

			const nextItem = this.items[index + 1];
			const nextRect = nextItem.getBoundingClientRect();
			const distanceToTop = nextRect.top;

			if (distanceToTop < viewportHeight && distanceToTop > 0) {
				const progress = 1 - distanceToTop / viewportHeight;
				const scale = 1 - progress * 0.05;
				const opacity = 1 - progress * 0.2;

				item.style.transform = `scale(${scale})`;
				item.style.opacity = opacity;
			} else if (distanceToTop >= viewportHeight) {
				item.style.transform = 'scale(1)';
				item.style.opacity = '1';
			}
		});
	}
}

customElements.define('scrolling-row', ScrollingRow);

class ScrollingHandler extends HTMLElement {
	constructor() {
		super();

		this.width     = 0;
		this.scrolling = this.querySelector( '.scrolling-inner' );

		window.addEventListener( 'DOMContentLoaded', this.handler.bind( this ) );
		window.addEventListener( 'resize', this.handler.bind( this ) );

		document.addEventListener( 'shopify:section:load', this.handler.bind( this ) );
		document.addEventListener( 'shopify:section:select', this.handler.bind( this ) );
		document.addEventListener( 'shopify:block:select', this.handler.bind( this ) );
		document.addEventListener( 'product-card-updated', this.handler.bind( this ) );
	}

	handler() {
		if ( this.width == window.innerWidth ) {
			return;
		}

		this.width = window.innerWidth;
		this.scrolling.classList.remove( 'scrolling-animation' );
		let boxes = this.querySelectorAll( '.scrolling-dup' );
		if ( boxes.length ) {
			boxes.forEach(e => e.remove());
		}

		let localWidth = this.closest( '.scrolling-wrapper' ).offsetWidth,
			length     = localWidth / this.scrolling.offsetWidth,
			dup        = false;

		length = length == Infinity ? 5 : length;

		for ( let i = 0; i < length; i++ ) {
			dup = this.scrolling.cloneNode( true );
			dup.classList.add( 'scrolling-dup', 'scrolling-animation' );
			this.prepend( dup );
		}

		this.scrolling.classList.add( 'scrolling-animation' );
	}
}
customElements.define( 'scrolling-item', ScrollingHandler );






// Featured product slider.


// class ParallaxBanner extends HTMLElement {
// 	constructor() {
// 		super();
// 		this._raf = null;
// 		this._onScroll = this._onScroll.bind(this);
// 	}

// 	connectedCallback() {
// 		this.speed = parseFloat(this.dataset.speed) || 0.25;
// 		this.scale = parseFloat(this.dataset.scale) || 1.5;

// 		this.image = this.querySelector('.banner-image:not(.hidden-desktop)');
// 		if (!this.image) return;

// 		this.img = this.image.querySelector('img');
// 		if (!this.img) return;

// 		this._prepareImage();
// 		this._onScroll();
// 		window.addEventListener('scroll', this._onScroll, { passive: true });
// 		window.addEventListener('resize', this._onScroll);
// 	}

// 	disconnectedCallback() {
// 		window.removeEventListener('scroll', this._onScroll);
// 		window.removeEventListener('resize', this._onScroll);
// 		cancelAnimationFrame(this._raf);
// 	}

// 	_prepareImage() {
// 		this.style.position = 'relative';
// 		this.style.overflow = 'hidden';

// 		this.image.style.willChange = 'transform';
// 		this.img.style.transform = `scale(${this.scale})`;
// 		this.img.style.transformOrigin = 'center';
// 	}

// 	_onScroll() {
// 		if (this._raf) return;

// 		this._raf = requestAnimationFrame(() => {
// 			this._raf = null;

// 			const rect = this.getBoundingClientRect();
// 			const vh = window.innerHeight;

// 			if (rect.bottom <= 0 || rect.top >= vh) return;

// 			const sectionCenter = rect.top + rect.height / 2;
// 			const distance = sectionCenter - vh / 2;

// 			const maxOffset = rect.height * (this.scale - 1) / 2;
// 			let offset = distance * this.speed;
// 			offset = Math.max(-maxOffset, Math.min(maxOffset, offset));

// 			this.image.style.transform = `translateY(${offset}px)`;
// 		});
// 	}
// }

// customElements.define('parallax-banner', ParallaxBanner);






class LoadMore extends HTMLElement {
	constructor() {
		super();
		this.items          = [...document.querySelectorAll( '.location-grid-section .column-item' )];
		this.loadMoreButton = document.querySelector( '.location-grid-section .load-more' );
		this.currentIndex   = 0;
		this.itemsPerLoad   = this.getItemsPerRow();
		this.handleResize   = this.handleResize.bind( this );
	}

	connectedCallback() {
		this.init();
		window.addEventListener( 'resize', this.handleResize );
	}

	disconnectedCallback() {
		window.removeEventListener( 'resize', this.handleResize );
	}

	getItemsPerRow() {
		return parseInt( document.querySelector( '.location-grid-section .multicolumn-inner' ).getAttribute( 'data-row' ), 10 );
	}

	init() {
		this.itemsPerLoad = this.getItemsPerRow();
		let initialLoad   = this.itemsPerLoad * 2;

		this.items.forEach(( item, index ) => {
			item.style.display = index < initialLoad ? 'block' : 'none';
		});

		this.currentIndex = initialLoad;
		this.updateButtonState();
		this.loadMoreButton.addEventListener( 'click', () => this.loadItems() );
	}

	loadItems() {
		let endIndex = this.currentIndex + this.itemsPerLoad;

		this.items.slice( this.currentIndex, endIndex ).forEach(item => {
			item.style.display = 'block';
		});

		this.currentIndex = endIndex;
		this.updateButtonState();
	}

	updateButtonState() {
		this.loadMoreButton.style.display = (this.currentIndex >= this.items.length) ? 'none' : 'block';
	}

	handleResize() {
		this.itemsPerLoad = this.getItemsPerRow();
	}
}

customElements.define( 'load-more', LoadMore );
document.addEventListener( 'DOMContentLoaded', () => {
    const checkGrid = setInterval(() => {
        if ( document.querySelector( '.location-grid-section .multicolumn-inner' ) ) {
            clearInterval( checkGrid );
            new LoadMore();
        }
    }, 100);
});

// Marquee.
class MarqueeHandler extends HTMLElement {
	constructor() {
		super();

		this.width = 0;
		this.marquee = this.querySelector( '.marquee-wrapper' );
		setTimeout( this.resizeHandler.bind( this ), 100 );
		window.addEventListener( 'resize', this.resizeHandler.bind( this ), false );
		this.querySelectorAll( '[loading]' ).forEach(
			( item ) => {
				item.removeAttribute( 'loading' );
			}
		);
	}
	resizeHandler(){
		if ( this.width == window.innerWidth ) {
			return;
		}

		this.width = window.innerWidth;
		this.marquee.classList.remove( 'marquee-animation' );
		let boxes = this.querySelectorAll( '.marquee-dup' );

		if ( boxes.length ) {
			boxes.forEach(e => e.remove());
		}

		let local_width = this.closest( '.marquee-section' ).offsetWidth,
			length      = local_width / this.marquee.offsetWidth,
			dup         = false;

		length = length == Infinity ? 5 : length;

		for ( let i = 0; i < length; i++ ) {
			dup = this.marquee.cloneNode( true );
			dup.classList.add( 'marquee-dup', 'marquee-animation' );
			this.prepend( dup );
		}

		this.marquee.classList.add( 'marquee-animation' );
	}
}
customElements.define( 'marquee-section', MarqueeHandler );

// Marquee vertical.
class MarqueeHandlerHeight extends HTMLElement {
	constructor() {
		super();

		this.height  = 0;
		this.marquee = this.querySelector( '.two-marquee .marquee-wrapper' );

		setTimeout( this.resizeHandler.bind( this ), 100 );
		window.addEventListener( 'resize', this.resizeHandler.bind( this ), false );

		this.querySelectorAll( '[loading]' ).forEach( ( item ) => {
			item.removeAttribute( 'loading' );
		});
	}

	resizeHandler() {
		if (this.height === window.innerHeight) {
			return;
		}

		this.height = window.innerHeight;
		this.marquee.classList.remove( 'marquee-animation' );

		let boxes = this.querySelectorAll( '.marquee-dup' );
		if (boxes.length) {
			boxes.forEach( ( e ) => e.remove() );
		}

		let marqueeSection = this.closest( '.two-columns' );

		if ( ! marqueeSection ) {
			return;
		}

		let local_height = marqueeSection.offsetHeight,
			length       = local_height / this.marquee.offsetHeight,
			dup          = false;

		length = length === Infinity?5 : Math.ceil( length );

		for (let i = 0; i < length; i++) {
			dup = this.marquee.cloneNode( true );
			dup.classList.add( 'marquee-dup' );
			this.append( dup );
		}

		setTimeout(() => {
			this.querySelectorAll( '.marquee-dup, .marquee-wrapper' ).forEach(( item ) => {
				item.classList.add( 'marquee-animation' );
			});
		}, 50);
	}
}

customElements.define( 'marquee-vertical', MarqueeHandlerHeight );
// Marquee.
class ScrollingTextHandler extends HTMLElement {
	constructor() {
		super();

		this.width = 0;
		this.scrolling = this.querySelector( '.scrolling-wrapper' );
		setTimeout( this.resizeHandler.bind( this ), 100 );
		window.addEventListener( 'resize', this.resizeHandler.bind( this ), false );
		this.querySelectorAll( '[loading]' ).forEach(
			( item ) => {
				item.removeAttribute( 'loading' );
			}
		);
	}

	connectedCallback() {
		this.width   = 0;
		this.wrapper = this.parentNode;
		this.item    = this.querySelector( '.scrolling-animation' );

		window.addEventListener( 'DOMContentLoaded', this.resizeHandler.bind( this ) );
		window.addEventListener( 'resize', this.resizeHandler.bind( this ) );

		document.addEventListener( 'shopify:section:load', this.resizeHandler.bind( this ) );
		document.addEventListener( 'shopify:section:select', this.resizeHandler.bind( this ) );
		document.addEventListener( 'shopify:block:select', this.resizeHandler.bind( this ) );
	}

	resizeHandler(){
		if ( this.width == window.innerWidth ) {
			return;
		}

		this.width = window.innerWidth;
		this.scrolling.classList.remove( 'scrolling-animation' );
		let boxes = this.querySelectorAll( '.scrolling-dup' );

		if ( boxes.length ) {
			boxes.forEach(e => e.remove());
		}

		let local_width = this.offsetWidth,
			length      = local_width / this.scrolling.offsetWidth,
			dup         = false;

		length = length == Infinity ? 5 : length;

		for ( let i = 0; i < length; i++ ) {
			dup = this.scrolling.cloneNode( true );
			dup.classList.add( 'scrolling-dup', 'scrolling-animation' );
			this.prepend( dup );
		}

		this.scrolling.classList.add( 'scrolling-animation' );
	}
}
customElements.define( 'scrolling-promotion-section', ScrollingTextHandler );






// Update Progress Bar Cart.



// Minicart recommendations.



// Side cart click outer popup.



// Cart checkbox agree to terms.



// Side cart update product item when apply discount.













/**
 * Theme js
 *
 * @package Dev
 */

'use strict';

// Set scrollbar width.
function btyScrollBar( doc = document ) {
	let domId = document.getElementById( 'dynamic-variables-theme-css' );
	if ( ! domId ) {
		return;
	}

	let scrollbarWidth = window.innerWidth - document.body.clientWidth,
		megaMenu       = doc.querySelector( '.header-nav .mega-menu-wrap' ),
		currentWidth   = window.innerWidth - document.documentElement.clientWidth;

	// Custom event.
	const scrollbarEvent = new Event( 'scrollbar-width' );

	const observer = new ResizeObserver(() => {
		const newWidth = window.innerWidth - document.documentElement.clientWidth;

		if ( newWidth !== currentWidth ) {
			scrollbarEvent.detail = {
				previous: currentWidth,
				current: newWidth
			};

			currentWidth = newWidth;

			window.dispatchEvent( scrollbarEvent );
		}
	});

	observer.observe( document.documentElement );

	// First load.
	const updateContainerContent = function() {
		const initialWidth = window.innerWidth - document.documentElement.clientWidth;
		domId.innerHTML = ':root{--scrollbar-width:' + initialWidth + 'px;--container-content:' + ( megaMenu ? megaMenu.offsetWidth : 0 ) + 'px}';
	}

	updateContainerContent();
	window.addEventListener( 'resize', updateContainerContent );

	// Start listening for changes.
	window.addEventListener(
		'scrollbar-width',
		function( e ) {
			let newMegaMenu = doc.querySelector( '.header-nav .mega-menu-wrap .container .mega-menu' );
			domId.innerHTML = ':root{--scrollbar-width:' + e.detail.current + 'px;--container-content:' + ( newMegaMenu ? newMegaMenu.offsetWidth : 0 ) + 'px}';
		}
	);

	return observer;
}

// Siblings.
function btySiblings( el, filter ) {
	// create an empty array.
	let siblings = [];

	// if no parent, return empty list.
	if ( ! el || ! el.parentNode ) {
		return siblings;
	}

	// first child of the parent node.
	let sibling = el.parentNode.firstElementChild;

	// loop through next siblings until `null`.
	do {
		// push sibling to array.
		if ( sibling != el && ( ! filter || filter( sibling ) ) ) {
			siblings.push( sibling );
		}
	} while ( sibling = sibling.nextElementSibling );

	return siblings;
}

// Slide up.
function btySlideUp( target, duration = 200 ) {
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.height             = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow      = 'hidden';
	target.style.height        = 0;
	target.style.paddingTop    = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop     = 0;
	target.style.marginBottom  = 0;

	window.setTimeout(
		function() {
			target.style.display = 'none';
			target.style.removeProperty( 'height' );
			target.style.removeProperty( 'padding-top' );
			target.style.removeProperty( 'padding-bottom' );
			target.style.removeProperty( 'margin-top' );
			target.style.removeProperty( 'margin-bottom' );
			target.style.removeProperty( 'overflow' );
			target.style.removeProperty( 'transition-duration' );
			target.style.removeProperty( 'transition-property' );
		},
		duration
	);
}

// Slide down.
function btySlideDown( target, duration = 200 ) {
	target.style.removeProperty( 'display' );
	let display = window.getComputedStyle( target ).display;

	if ( 'none' === display ) {
		display = 'block';
	}

	target.style.display = display;

	let height = target.offsetHeight;

	target.style.overflow      = 'hidden';
	target.style.height        = 0;
	target.style.paddingTop    = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop     = 0;
	target.style.marginBottom  = 0;
	target.offsetHeight;
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + 'ms';
	target.style.height             = height + 'px';

	target.style.removeProperty( 'padding-top' );
	target.style.removeProperty( 'padding-bottom' );
	target.style.removeProperty( 'margin-top' );
	target.style.removeProperty( 'margin-bottom' );

	window.setTimeout(
		function() {
			target.style.removeProperty( 'height' );
			target.style.removeProperty( 'overflow' );
			target.style.removeProperty( 'transition-duration' );
			target.style.removeProperty( 'transition-property' );
		},
		duration
	);
}

// Toggle dropdown.
function btyToggleDropdown( doc = document ) {
	let toggle = doc.querySelectorAll( '.toggle-dropdown .dropdown-summary' );
	if ( ! toggle.length ) {
		return;
	}

	toggle.forEach(
		function( el ) {
			let parent      = el.parentNode,
				title       = el.querySelector( '.summary-info' ),
				mobileTitle = el.parentNode.querySelector( '.dropdown-content-title' ),
				closeButton = el.parentNode.querySelector( '[data-dropdown-close]' );

			const closeDropdown = function( returnFocus = false ) {
				parent.removeAttribute( 'open' );
				el.setAttribute( 'aria-expanded', 'false' );
				document.removeEventListener( 'click', clickAnyWhere );
				document.removeEventListener( 'keydown', handleKeydown );

				if ( returnFocus ) {
					el.focus();
				}
			}

			const clickAnyWhere = function( e ) {
				let target = e.target;

				if ( target === el || target.classList.contains( 'content' ) || target.closest( '.dropdown-summary' ) ) {
					return;
				}

				if ( target.classList.contains( 'tab-head', 'active' ) ) {
					if ( title ) {
						title.innerText = target.innerText;
					}

					if ( mobileTitle ) {
						mobileTitle.innerText = target.innerText;
					}
				}

				closeDropdown();
			}

			const handleKeydown = function( e ) {
				if ( e.key !== 'Escape' || ! parent.hasAttribute( 'open' ) ) {
					return;
				}

				e.preventDefault();
				closeDropdown( true );
			}

			el.onclick = function( e ) {
				if ( parent.hasAttribute( 'open' ) ) {
					closeDropdown();
				} else {
					let sibling = parent.parentNode.querySelector( '.toggle-dropdown[open]' );
					if ( sibling ) {
						sibling.removeAttribute( 'open' );

						let sibAria = sibling.querySelector( '.dropdown-summary[aria-expanded]' );
						if ( sibAria ) {
							sibAria.setAttribute( 'aria-expanded', 'false' );
						}
					}

					parent.setAttribute( 'open', '' );
					el.setAttribute( 'aria-expanded', 'true' );
					document.addEventListener( 'click', clickAnyWhere );
					document.addEventListener( 'keydown', handleKeydown );
				}
			}

			if ( closeButton ) {
				closeButton.onclick = function() {
					closeDropdown( true );
				}
			}
		}
	);
}

// Update aria expanded for summary <details> tag only.
function btyToggleDetails( doc = document ) {
	let details = doc.querySelectorAll( 'details' );
	if ( ! details.length ) {
		return;
	}

	details.forEach(
		function( el ) {
			let summary = el.querySelector( 'summary' );
			if ( el.classList.contains( 'product-accordion' ) || el.classList.contains( 'collapsible-item' ) || el.classList.contains( 'order-note' ) || ! summary ) {
				return;
			}

			document.addEventListener(
				'click',
				function( e ) {
					let target = e.target;

					if ( target === el || el.contains( target ) || target.closest( '.toggle-dropdown' ) ) {
						return;
					}

					let tmpAria = doc.querySelector( '[open] [aria-expanded]' );
					if ( tmpAria ) {
						tmpAria.setAttribute( 'aria-expanded', 'false' );
					}
				}
			);

			el.onclick = function( e ) {
				let aria = summary.getAttribute( 'aria-expanded' );
				if ( ! aria ) {
					return;
				}

				if ( 'string' === typeof( el.getAttribute( 'open' ) ) ) {
					if ( aria ) {
						summary.setAttribute( 'aria-expanded', 'false' );
					}
				} else {
					let sibling = el.parentNode.querySelector( '[open]' );
					if ( sibling ) {
						let sibAria = sibling.querySelector( '[open] [aria-expanded]' );
						if ( sibAria ) {
							sibAria.setAttribute( 'aria-expanded', 'false' );
						}
					}

					if ( aria ) {
						summary.setAttribute( 'aria-expanded', 'true' );
					}
				}
			}
		}
	);
}

// Json parse.
function btyJsonParse( string ) {
	try {
		return JSON.parse( string.trim() );
	} catch ( e ) {
		return false;
	}
}

// Remove item in array.
function btyRemoveArrayItem( arr = [], item ) {
	if ( ! arr.length || ! item ) {
		return [];
	}

	return arr.filter(
		function( el ) {
			return el != item;
		}
	);
}

// Set delay time when user typing.
const btySearchDelay = function( timer = 0 ) {
	return function( callback, ms ) {
		clearTimeout( timer );
		timer = setTimeout( callback, ms );
	};
}();

// Get image src.
function btyGetImageSrc( img ) {
	// Create canvas.
	let canvas  = document.createElement( 'canvas' ),
		context = canvas.getContext( '2d' );

	// Set width and height.
	canvas.width  = img.width;
	canvas.height = img.height;

	// Draw the image.
	context.drawImage( img, 0, 0 );

	return canvas.toDataURL( 'image/jpeg', 1.0 );
}

// Google map.
function btyGoogleMap( doc = document ) {
	let selectors = doc.querySelectorAll( '.contact-map' );
	if ( ! selectors.length ) {
		return;
	}

	// Map style.
	let styledMapType = new google.maps.StyledMapType(
		[
			{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [{ "color": "#444444" }]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "all",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [{ "color": "#f2f2f2" }]
			},
			{
				"featureType": "landscape.natural",
				"elementType": "all",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "poi",
				"elementType": "all",
				"stylers": [
					{ "visibility": "on" },
					{ "color": "#052366" },
					{ "saturation": "-70" },
					{ "lightness": "85" }
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels",
				"stylers": [
					{ "visibility": "simplified" },
					{ "lightness": "-53" },
					{ "weight": "1.00" },
					{ "gamma": "0.98" }
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels.icon",
				"stylers": [{ "visibility": "simplified" }]
			},
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [
					{ "saturation": -100 },
					{ "lightness": 45 },
					{ "visibility": "on" }
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [{ "saturation": "-18" }]
			},
			{
				"featureType": "road",
				"elementType": "labels",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "road.highway",
				"elementType": "all",
				"stylers": [{ "visibility": "on" }]
			},
			{
				"featureType": "road.arterial",
				"elementType": "all",
				"stylers": [{ "visibility": "on" }]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.icon",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "road.local",
				"elementType": "all",
				"stylers": [{ "visibility": "on" }]
			},
			{
				"featureType": "transit",
				"elementType": "all",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
					{ "color": "#57677a" },
					{ "visibility": "on" }
				]
			}
		],
		{ name: "Styled Map" }
	);

	// Init.
	selectors.forEach(
		function( el ) {
			let data    = el.querySelector( '[data-options]' ),
				options = data ? btyJsonParse( data.content.textContent ) : false;
			if ( ! options ) {
				return;
			}

			// Remove template.
			data.remove();

			let coordinates = options.coordinates.split( ',' );

			coordinates = { lat: Number( coordinates[0].trim()), lng: Number( coordinates[1].trim()) }

			let map = new google.maps.Map(
				el,
				{
					zoom: options.zoom,
					center: coordinates,
					disableDefaultUI: true,
					mapTypeControlOptions: {
						mapTypeIds: [ 'roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map' ]
					}
				}
			);

			map.mapTypes.set( 'styled_map', styledMapType );
			map.setMapTypeId( 'styled_map' );

			let marker = new google.maps.Marker(
				{
					position: coordinates,
					map: map
				}
			);
		}
	);
}

// Scrolling detect direction.
function btyScrollingDetect() {
	let body = document.body;

	if ( window.oldScroll > window.scrollY ) {
		body.classList.add( 'direction-up' );
		body.classList.remove( 'direction-down' );
	} else {
		body.classList.remove( 'direction-up' );
		body.classList.add( 'direction-down' );
	}

	// Reset state.
	window.oldScroll = window.scrollY;
}

// Set loading animation for image.
function btyImageLoad( image, image_src, image_key, ele_loading ) {
	let newImage = new Image();

	newImage.crossOrigin = 'anonymous';

	// Check local storage first.
	if ( sessionStorage.getItem( image_key ) ) {
		image.src = sessionStorage.getItem( image_key );
		return;
	}

	// Add loading animation.
	image.parentNode.classList.add( 'loading' );

	// Handle.
	newImage.onload = function() {
		ele_loading.classList.remove( 'loading' );
		let renderImage = btyGetImageSrc( newImage );

		// Set final image src.
		image.src = renderImage;

		// Save image to local storage.
		if ( image_key ) {
			sessionStorage.setItem( image_key, renderImage );
		}
	}

	newImage.onerror = function() {
		ele_loading.classList.remove( 'loading' );
	}

	// Set image src for 'newImage.onload' function handle.
	newImage.src = image_src;
}

// Get form data.
function btySerializeForm( form, type = 'string' ) {
	let obj      = {},
		formData = new FormData( form );

	for ( let key of formData.keys() ) {
		obj[ key ] = formData.get( key );
	}

	return 'string' === type ? JSON.stringify( obj ) : obj;
};

// Get price format.



// Render price html.



// Keep the price container state in sync when a product variant changes.



// Render the compact price used inside Add to cart buttons.






// Resolve the actual variant price for the active one-time or subscription purchase option.












// Open the STOQ back-in-stock signup modal from the theme's main and sticky buttons.



// Parse html dom.
function btyGetSectionHtml( text = '', selector = '.shopify-section', html = 'inner' ) {
	let el = new DOMParser().parseFromString( text, 'text/html' ).querySelector( selector );

	return el ? ( 'inner' === html ? el.innerHTML : el.outerHTML ) : '';
}

/**
 * Update html dom.
 *
 * @param  array sections The response sections.
 * @param  array modules  The modules need update html dom.
 */
function btyUpdateHtml( sections, modules ) {
	modules.forEach(
		function( mod ) {
			let query = document.querySelectorAll( mod.node );
			if ( ! query.length ) {
				return;
			}

			query.forEach(
				function( el ) {
					el.innerHTML = btyGetSectionHtml( sections[ mod.section ], mod.selector );
				}
			);

			// Re-init function.
			btyAddToCart();
			btySwatch();
			btyQuickAdd();
		}
	);
}

// Countdown time.
function btyCountdownTime( doc = document ) {
	let selectors = doc.querySelectorAll( '.countdown-time' );

	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let time        = el.getAttribute( 'data-time' ),
				dayField    = el.querySelector( '.days' ),
				hourField   = el.querySelector( '.hours' ),
				minuteField = el.querySelector( '.minutes' ),
				secondField = el.querySelector( '.seconds' );

			if ( ! dayField || ! hourField || ! minuteField || ! secondField ) {
				return;
			}

			// Check time first.
			if ( isNaN( Date.parse( time ) ) ) {
				return;
			}

			// Convert to milisecond.
			let interval,
				second = 1000,
				minute = second * 60,
				hour   = minute * 60,
				day    = hour * 24,
				today  = new Date();

			const countDownFn = function() {
				let countDown = new Date( time ).getTime(),
					now       = new Date().getTime(),
					distance  = countDown - now,
					dayInner  = Math.floor( distance / day );

				if ( distance < 0 ) {
					el.parentNode.remove();

					clearInterval( init );

					return;
				}

				if ( 0 == dayInner && dayField ) {
					dayField.parentNode.remove();
				} else {
					dayField.innerText = dayInner;
				}

				hourField.innerText   = ( '0' + Math.floor( ( distance % day ) / hour ) ).slice( -2 );
				minuteField.innerText = ( '0' + Math.floor( ( distance % hour ) / minute ) ).slice( -2 );
				secondField.innerText = ( '0' + Math.floor( ( distance % minute ) / second ) ).slice( -2 );

				// Show countdown.
				el.parentNode.classList.remove( 'hidden' );
			}

			let init = setInterval( countDownFn, 0 );
		}
	);
}

/**
 * Close theme popup
 *
 * @param  string class_name  Class name remove form <html>
 * @return node   parent_node Parent node to implement click overlay.
 */
function btyClosePopup(class_name, parent_node, overlay = true) {
	if (!class_name) return;

	let doc = document.documentElement,
		button = parent_node ? parent_node.querySelector('.close-button, .side-cart-close') : false;

	// CLICK OVERLAY.
	if (parent_node && overlay) {
		const parentHandle = function (e) {
			if (e.target != parent_node) return;

			doc.classList.remove(class_name);

			parent_node._lastFocused?.focus();

			parent_node.removeEventListener('click', parentHandle);
			document.dispatchEvent(new CustomEvent('theme-popup-close'));
		};

		parent_node.addEventListener('click', parentHandle);
	}

	// ESC KEY.
	doc.addEventListener('keyup', function (e) {
		if (e.keyCode !== 27) return;

		doc.classList.remove(class_name);

		parent_node?._lastFocused?.focus();

		document.dispatchEvent(new CustomEvent('theme-popup-close'));
	});

	// CLOSE BUTTON.
	if (button) {
		const buttonHandle = function () {
			doc.classList.remove(class_name);

			parent_node?._lastFocused?.focus();

			button.removeEventListener('click', buttonHandle);
			document.dispatchEvent(new CustomEvent('theme-popup-close'));
		};

		button.addEventListener('click', buttonHandle);
	}
}

// Quick search.



// Quantity button.



// Keep the main product and sticky Add to cart forms on one quantity value.









// Main menu.
function btyNavMenu( doc = document, event = false ) {
	let toggles = doc.querySelectorAll( '.toggle-panel-button' ),
		panel  = doc.querySelector( '.site-panel' );

	if ( ! toggles.length || ! panel ) {
		return;
	}

	// Close site panel when settings update.
	if ( event && event.detail.load ) {
		btyClosePopup( 'site-panel-open', panel );
	}

	toggles.forEach(
		function( el ) {
			// Toggle site panel.
			el.onclick = function() {
				document.documentElement.classList.add( 'site-panel-open' );

				btyClosePopup( 'site-panel-open', panel );
			}
		})

	// Toggle sub menu.
	let links = doc.querySelectorAll( '.site-panel .has-children' );
	if ( ! links.length ) {
		return;
	}

	links.forEach(
		function( el ) {
			el.onclick = function( e ) {
				if ( e.target.classList.contains( 'menu-text' ) && !el.contains(e.target) ) {
					return;
				}

				e.preventDefault();

				let menu    = el.closest( '.toggle-navigation' ),
					parent  = el.parentNode,
					subMenu = parent.querySelector( '.sub-menu' ) || parent.querySelector( '.sub-mega-menu' );
				if ( ! subMenu ) {
					return;
				}

				parent.classList.add( 'active' );

				// Update current sub menu.
				let level = Number( subMenu.getAttribute( 'data-level' ) || 1 ),
					back  = parent.querySelector( '.back' );
				if ( level ) {
					menu.setAttribute( 'data-level', level );
				}

				// Go back parent level.
				if ( back ) {
					back.onclick = function() {
						parent.classList.remove( 'active' );
						menu.setAttribute( 'data-level', level - 1 );
					}
				}
			}
		}
	);
}

// Split Slider.



// Account popup.
function btyAccountPopup( doc = document ) {
	let selectors = doc.querySelectorAll( '.action-account' ),
		customer  = document.querySelector( '.customer-wraper' );
	if ( ! selectors.length || ! customer || document.body.classList.contains( 'has-account-details' ) ) {
		return;
	}

	// Get display style.
	const getStyles = function( el, property = 'display' ) {
		let obj = window.getComputedStyle( el, null );

		return obj.getPropertyValue( property );
	}

	// Get first input field.
	const getInput = function( parent ) {
		return parent.querySelector( '.field input' );
	}

	// Toggle popup.
	selectors.forEach(
		function( el ) {
			el.onclick = function( e ) {
				if ( el.classList.contains( 'new-customer-accounts' ) ) {
					return;
				}

				e.preventDefault();

				let login    = customer.querySelector( '.login' ),
					loginBox = login ? login.querySelector( '#login-container' ) : false,
					recover  = login ? login.querySelector( '#recover-container' ) : false,
					register = customer.querySelector( '.register' );

				if ( ! recover || ! loginBox || ! register ) {
					return;
				}

				document.documentElement.classList.add( 'customer-open' );

				// Focus input field on desktop.
				if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
					if ( getStyles( register ) === 'block' ) {
						getInput( register ).focus();
					} else if ( getStyles( recover ) === 'block' ) {
						getInput( recover ).focus();
					} else if ( getStyles( loginBox ) === 'block' ) {
						getInput( loginBox ).focus();
					}
				}

				// Close popup.
				btyClosePopup( 'customer-open', customer );

				customer.onclick = function( e ) {
					let target = e.target;

					// Create account.
					if ( target.classList.contains( 'create-account' ) ) {
						e.preventDefault();

						login.classList.add( 'hidden' );
						register.classList.remove( 'hidden' );

						getInput( register ).focus();
					}

					// Sign-in.
					if ( target.classList.contains( 'sign-in' ) ) {
						e.preventDefault();

						login.classList.remove( 'hidden' );
						register.classList.add( 'hidden' );

						getInput( loginBox ).focus();
					}

					// Fogot password.
					if ( target.classList.contains( 'forgot-password' ) ) {
						setTimeout(
							function() {
								getInput( recover ).focus();
							}
						);
					}

					// Cancel login.
					if ( target.classList.contains( 'login-cancel' ) ) {
						setTimeout(
							function() {
								getInput( loginBox ).focus();
							}
						);
					}
				}
			}
		}
	);
}

// Update cart item count.



// Find if two arrays contain any common item in Javascript.
function btyDiffObject( haystack, arr ) {
	return arr.every(
		function( v ) {
			return haystack.includes( v );
		}
	);
};

// Selected variant image.



// Fetch cart data.



// Update product quantity.



// Variant options.



// Quick view variant options.



// Quick view.



// Update storage.



// Update variants on popup.



// Open the theme side cart used across the storefront.



// Route every theme cart icon to the active theme side cart.



// Get fetch config.



// ValidateEmail.






// Ajax add to cart.



// Ajax add all set to cart.



// Check product inventory.



/**
 * Update stock status
 *
 * @param  object variants The product variants.
 * @param  node   siblings The product card.
 */



/**
 * Update stock status for product page
 *
 * @param  object variants The product variants.
 * @param  node   siblings The product card.
 */



// Quick add.



// Swatch list.



// Product tabs.




// Video.
function btyVideo( doc = document ) {
	let selectors = doc.querySelectorAll( '.video-item' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let imageWrapper = el.querySelector( '.video-image-wrapper' );

			if ( ! imageWrapper ) {
				return;
			}

			let playBtn = el.querySelector('.play-video');
			if (playBtn) {
				playBtn.addEventListener('click', function(e) {
					e.preventDefault();
					imageWrapper.click();
				});
			}

			imageWrapper.addEventListener(
				'click',
				function() {
					let iframe = el.querySelector( 'iframe' ),
						video  = el.querySelector( 'video' );

					if ( iframe ) {
						iframe.src = iframe.getAttribute( 'data-src' );

						btyMediaAction( el, 'play' );
					}

					if ( video ) {
						video.setAttribute( 'data-ready', '' );

						let playPromise = video.play();
						if ( undefined !== playPromise ) {
							playPromise.then(
								function() {}
							).catch(
								function( error ) {
									console.log( error );
								}
							);
						}
					}
				}
			);
		}
	);
}

// Video background.
function btyBackgroundVideo( doc = document ) {
	let selectors = doc.querySelectorAll( '.toggle-popup-bg-video' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			el.addEventListener(
				'click',
				function() {
					let section = el.closest( '.video-background-section' ),
						popup   = section ? section.querySelector( '.background-video-popup' ) : false,
						iframe  = popup ? popup.querySelector( 'iframe' ) : false,
						video   = popup ? popup.querySelector( 'video' ) : false;

					if ( ! popup ) {
						return;
					}

					document.documentElement.classList.add( 'bg-video-popup-open' );
					btyClosePopup( 'bg-video-popup-open', popup );

					if ( iframe ) {
						iframe.src = iframe.getAttribute( 'data-src' );

						btyMediaAction( popup, 'play' );
					}

					if ( video ) {
						video.setAttribute( 'data-ready', '' );

						let playPromise = video.play();
						if ( undefined !== playPromise ) {
							playPromise.then(
								function() {}
							).catch(
								function( error ) {
									console.log( error );
								}
							);
						}
					}
				}
			);
		}
	);
}

// Action for media.
function btyMediaAction( doc = document, type = 'pause' ) {
	let video = doc.querySelectorAll( '.js-youtube, .js-vimeo, video' );
	if ( ! video.length ) {
		return;
	}

	let youtubeFunc = 'stopVideo';

	switch ( type ) {
		case 'pause':
			youtubeFunc = 'pauseVideo';
			break;
		case 'play':
			youtubeFunc = 'playVideo';
			break;
		case 'stop':
			youtubeFunc = 'stopVideo';
			break;
	}

	if ( video.length ) {
		video.forEach(
			function( vd ) {
				if ( 'video' === vd.tagName.toLowerCase() ) {
					let playPromise = vd.play();

					if ( 'pause' === type ) {
						if ( undefined !== playPromise ) {
							playPromise.then(
								function() {
									vd.pause();
								}
							).catch(
								function( error ) {
									console.log( error );
								}
							);
						}
					} else {
						if ( undefined !== playPromise ) {
							playPromise.then(
								function() {}
							).catch(
								function( error ) {
									console.log( error );
								}
							);
						}
					}
				} else if ( vd.classList.contains( 'js-youtube' ) ) {
					vd.contentWindow.postMessage( '{"event":"command","func":"' + youtubeFunc + '","args":""}', '*' );
				} else if ( vd.classList.contains( 'js-vimeo' ) ) {
					vd.contentWindow.postMessage( '{"method":"' + type + '"}', '*' );
				}
			}
		);
	}
}

// Address box section.
function btyAddress( doc =document ) {
	let selectors = doc.querySelectorAll( '.address-box .address-summary' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let items = el.querySelectorAll( '.summary-item' );
			if ( items.length < 2 ) {
				return;
			}

			items.forEach(
				function( im, index ) {
					im.addEventListener(
						'click',
						function( e ) {
							e.preventDefault();

							const mobile = window.matchMedia( '(max-width: 767px)' ).matches;

							let oldActive = el.querySelector( '.summary-item.active' ),
								subBox    = im.querySelector( '.address-sub' ),
								image     = el.parentNode.querySelector( '.address-content-inner' );

							if ( im.classList.contains( 'active' ) ) {
								return;
							}

							if ( oldActive ) {
								let oldSubBox = oldActive.querySelector( '.address-sub' );
								if ( oldSubBox && mobile ) {
									btySlideUp( oldSubBox );
								}
								oldActive.classList.remove( 'active' );
							}

							if ( image ) {
								image.setAttribute( 'data-level', index );
							}

							im.classList.add( 'active' );

							if ( subBox && mobile ) {
								btySlideDown( subBox );
							}
						}
					);
				}
			);
		}
	);
}

// Pickup availability.



// Pickup availability for simple product.



// Popup content.



// Share button.



// Sale notification.
function btySalesNotification( doc = document ) {
	let selector = doc.querySelector( '.sales-notification' );
	if ( ! selector ) {
		return;
	}

	let inner   = selector.querySelector( '.sn-inner' ),
		options = selector.querySelector( '[data-options]' ),
		items   = selector.querySelector( '[data-items]' );
	if ( ! inner || ! options || ! items ) {
		return;
	}

	let parseOptions = btyJsonParse( options.content.textContent ),
		parseItems   = new DOMParser().parseFromString( items.innerHTML, 'text/html' );

	// Remove html template.
	options.remove();
	items.remove();

	let length = parseItems.querySelectorAll( '.sn-item' );
	if ( ! length.length ) {
		return;
	}

	// Get random item in array.
	const randomItem = function( arr = [] ) {
		return arr[ Math.floor( Math.random() * arr.length ) ];
	}

	// Display function.
	const displayFn = function() {
		let item     = randomItem( length ),
			time     = item.querySelector( '.sn-time' ),
			customer = item.querySelector( '.sn-customer' );

		// Append time text.
		if ( time ) {
			time.innerText = randomItem( parseOptions.virtual_times );
		}

		// Append customer text.
		if ( customer ) {
			customer.innerText = randomItem( parseOptions.virtual_customers ) + parseOptions.purchased;
		}

		inner.innerHTML = item.outerHTML;

		let current = inner.querySelector( '.sn-item' );
		if ( ! current ) {
			return;
		}

		// Set animation.
		setTimeout(
			function() {
				current.classList.add( 'active' );
			},
			50
		);

		// Start loading bar when animation end.
		setTimeout(
			function() {
				current.insertAdjacentHTML( 'beforeend', '<span class="underline-animated' + ( parseOptions.loading_bar ? '' : ' visibility-hidden' ) + '"></span>' );

				// Remove notification after animation end.
				let animation = current.querySelector( '.underline-animated' );
				if ( animation ) {
					animation.addEventListener(
						'animationend',
						function() {
							current.classList.add( 'down' );
						}
					);
				}
			},
			300
		);

		// Remove notification by click to Close button.
		let closeBtn = current.querySelector( '.sn-close' );
		if ( closeBtn ) {
			closeBtn.onclick = function() {
				current.classList.add( 'down' );
			}
		}
	}

	let init, timeTotal = parseOptions.time_total * 1000;
	setTimeout(
		function() {
			displayFn();

			init = setInterval( displayFn, timeTotal );
		},
		( parseOptions.time_init * 1000 )
	);
}

// Newsletter popup.
function btyNewsletterPopup( doc = document ) {
	let form = doc.querySelector( '.newsletter-popup-form' );
	if ( ! form ) {
		return;
	}

	let delay = form.getAttribute( 'data-delay' );

	setTimeout(
		function() {
			// Always show popup when Display mode set to Test mode.
			if ( Shopify.designMode && '' === form.getAttribute( 'data-mode' ) ) {
				form.parentNode.classList.add( 'closed' );
			} else {
				if ( 'test' === form.getAttribute( 'data-mode' ) ) {
					form.parentNode.classList.remove( 'closed' );
				} else {
					if ( form.classList.contains( 'first-visit' ) ) {
						const getCookie = new URLSearchParams( document.cookie.replaceAll( '&', '%26' ).replaceAll( '; ', '&' ) );
						if ( ! getCookie.get( 'newsletter-popup-cookie' ) ) {
							form.parentNode.classList.remove( 'closed' );
						}

						function setCookie( cname, cvalue, exdays ) {
							let d = new Date();

							d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000) );

							let expires = 'expires=' + d.toUTCString();

							document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
						}

						setCookie( 'newsletter-popup-cookie', 1, 30 );
					} else {
						form.parentNode.classList.remove( 'closed' );
					}
				}
			}

			const isAgeVerification = form.closest( '.age-verification-section' ) !== null;

			// Click to popup overlay.
			if ( ! isAgeVerification ) {
				form.addEventListener('click', function ( e ) {
					if ( e.target !== form ) return;
					form.parentNode.classList.add( 'closed' );
				});

				// Use ESC key.
				document.addEventListener('keyup', function ( e ) {
					if ( e.keyCode !== 27 ) return;
						form.parentNode.classList.add( 'closed' );
					});
				}

				// Use close buttons.
				const section = form.closest('.newsletter-popup-section');

				form.querySelectorAll('.close-button').forEach(btn => {
					btn.addEventListener('click', function (e) {
						e.preventDefault();
						e.stopPropagation();
						section.classList.add('closed');
					});
				});
			},
		Number( delay )
	);
}

// Age verification popup.
function btyAgeverificationPopup(doc = document) {
	// Function to check the cookies.
	function checkAgeVerification() {
		const cookieString = doc.cookie && doc.cookie.split('; ').find(row => row.startsWith('acceptAgeVerification='));
		if ( ! cookieString || Shopify.designMode ) {
			let allowSection = doc.querySelector( ".age-verification-section .allow" );
			if (allowSection) {
				allowSection.classList.remove( "hidden" );
			}
		}
	}

	// Function to set the cookie.
	function setCookie(name, value, days) {
		const d = new Date();
		d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = "expires=" + d.toUTCString();
		doc.cookie = `${name}=${value};${expires};path=/`;
	}

	// Check and attach event to the "Yes" button.
	let yesBtn = doc.querySelector( ".age-verification-section .yes-btn" );

	if (yesBtn) {
		yesBtn.addEventListener("click", function () {
			let allowSection = doc.querySelector( ".age-verification-section .allow" );
			if (allowSection) {
				allowSection.classList.add( "hidden" );
			}
			// Add 'closed' class and set cookie when clicking "Yes".
			let form = doc.querySelector( '.age-verification-section .newsletter-popup-form' );
			if (form) {
				form.parentNode.classList.add( 'closed' );
			}
			setCookie( 'acceptAgeVerification', 1, 30 );
		});
	}

	// Check and attach event to the "No" button.
	let noBtn = doc.querySelector( ".age-verification-section .no-btn" );
	if (noBtn) {
		noBtn.addEventListener("click", function () {
			let allowSection    = doc.querySelector( ".age-verification-section .allow" );
			let notAllowSection = doc.querySelector( ".age-verification-section .not-allow" );
			if (allowSection && notAllowSection) {
				allowSection.classList.add( "hidden" );
				notAllowSection.classList.remove( "hidden" );
			}
		});
	}

	// Check and attach event to the "Back" button.
	let backBtn = doc.querySelector( ".age-verification-section .back-btn" );
	if (backBtn) {
		backBtn.addEventListener("click", function () {
			let notAllowSection = doc.querySelector( ".age-verification-section .not-allow" );
			let allowSection    = doc.querySelector( ".age-verification-section .allow" );
			if (notAllowSection && allowSection) {
				notAllowSection.classList.add( "hidden" );
				allowSection.classList.remove( "hidden" );
			}
		});
	}

	// Call the cookie check function.
	checkAgeVerification();
}

// Cookies bar.
function btyCookiesBar( doc = document ) {
	let box    = doc.querySelector( '.cookies-bar' ),
		button = doc.querySelector( '.button-cookies' );

	if ( ! box || ! button || ( Shopify.designMode && '' === box.getAttribute( 'data-mode' ) ) ) {
		return;
	}

	const getCookie = new URLSearchParams( document.cookie.replaceAll( '&', '%26' ).replaceAll( '; ', '&' ) );
	if ( ! getCookie.get( 'acceptCookies' ) ) {
		box.classList.add( 'show' );
	}

	function setCookie( cname, cvalue, exdays ) {
		let d = new Date();

		d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000) );

		let expires = 'expires=' + d.toUTCString();

		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}

	button.onclick = function () {
		if ( '' === box.getAttribute( 'data-mode' ) ) {
			setCookie( 'acceptCookies', 1, 30 );
		} else {
			document.cookie = 'acceptCookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
		}

		box.classList.remove( 'show' );
	}
}

// Hover media video.
function btyHoverMediaVideo( doc = document ) {
	let selectors = doc.querySelectorAll( '.hover-media-video' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let parent = el.parentNode;

			parent.addEventListener(
				'mousemove',
				function( e ) {
					btyMediaAction( parent, 'play' );

					return;
				}
			);

			parent.addEventListener(
				'mouseleave',
				function( e ) {
					btyMediaAction( parent, 'pause' );

					return;
				}
			);
		}
	);
}

// Animation for image load.
function btyAnimationImageLoad( doc = document, delay = 0 ) {
	let images = doc.querySelectorAll( '.lazy-image img' );
	if ( ! images.length ) {
		return;
	}

	const imgLazyObserver = new IntersectionObserver(
		function( entries, observer ) {
			entries.forEach(
				function( entry ) {
					if ( entry.isIntersecting ) {
						if ( entry.target.dataset.src ) {
							entry.target.src = entry.target.dataset.src;
						}

						if ( entry.target.dataset.srcSet ) {
							entry.target.srcSet = entry.target.dataset.srcSet;
						} else if ( entry.target.dataset.srcset ) {
							entry.target.setAttribute( 'srcset', entry.target.dataset.srcset );
						}

						entry.target.removeAttribute( 'data-src' );
						entry.target.removeAttribute( 'data-srcset' );

						entry.target.addEventListener(
							'load',
							function () {
								entry.target.parentNode.classList.add( 'lazy-loaded' );
							}
						);

						observer.unobserve( entry.target );
					}
				}
			);
		},
		{
			rootMargin: '-20px 0px -20px 0px'
		}
	);

	images.forEach(
		function( img ) {
			if ( img.parentNode.classList.contains( 'lazy-loaded' ) ) {
				return;
			}

			imgLazyObserver.observe( img );
		}
	);
}

// Animation for animated-image-collage.
function btyAnimationCollageLoad(doc = document) {
	const sections = doc.querySelectorAll( '.collection-list-section' );

	if ( sections.length === 0 ) {
		return;
	}

	const observer = new IntersectionObserver(( entries, obs ) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const section = entry.target;

				section.querySelectorAll( '.lazy-image img' ).forEach(( img ) => {
					if (img.dataset.src) {
						img.src = img.dataset.src;
					}
					if (img.dataset.srcset) {
						img.srcset = img.dataset.srcset;
					}
					img.removeAttribute( 'data-src' );
					img.removeAttribute( 'data-srcset' );

					if (img.parentNode) {
						img.parentNode.classList.add( 'lazy-loaded' );
					}
				});

				obs.unobserve( section );
			}
		});
	}, { rootMargin: '50px' });

	sections.forEach(( section ) => observer.observe( section ));
}

// Collection sticky.
function btyCollectionSticky( doc = document ) {
	let items = doc.querySelectorAll( '.collection-sticky' );
	if ( ! items.length ) {
		return
	}

	const stickCollection = function() {
		items.forEach(
			function( el ) {
				let box        = el.querySelector( '.heading-box' ),
					subHeading = box ? box.querySelector( '.sub-heading .dynamic-label' ) : false,
					heading    = box ? box.querySelector( '.heading .dynamic-label' ) : false,
					button     = box ? box.querySelector( '.collection-list-button .dynamic-label' ) : false,
					cards      = el.querySelectorAll( '.card-item' );
				if ( ! cards.length ) {
					return;
				}

				for ( let i = 0, j = cards.length; i < j; i++ ) {
					let rect    = cards[i].getBoundingClientRect(),
						index   = i + 1,
						current = el.querySelector( '.card-item:nth-child(' + index + ')' );

					if ( ! current ) {
						return;
					}

					let title          = current.getAttribute( 'data-title' ),
						dataSubHeading = current.getAttribute( 'data-subheading' ),
						dataHeading    = current.getAttribute( 'data-heading' ),
						href           = current.getAttribute( 'data-href' );
					if ( rect.top <= 1 && ( rect.top >= rect.height * -1 ) ) {
						if ( button && button.innerText != title ) {
							if ( href.trim() ) {
								button.parentNode.href = href;
							}

							if ( title.trim() ) {
								button.innerText = title;
							}

							button.parentNode.classList.add( 'bounce-it' );
							setTimeout(
								function() {
									button.parentNode.classList.remove( 'bounce-it' );
								},
								1000
							);
						}

						if ( dataSubHeading.trim() && subHeading ) {
							subHeading.innerText = dataSubHeading;
						}

						if ( dataHeading.trim() && heading ) {
							heading.innerText = dataHeading;
						}
					}
				}
			}
		);
	}

	stickCollection();

	// Trigger.
	window.addEventListener(
		'scroll',
		function() {
			stickCollection();
		}
	);
}

// Recipient form.



// Load media.
function btyLoadMedia( selector = undefined, action = 'play' ) {
	if ( ! selector ) {
		return;
	}

	let wrapper = selector.querySelector( '.media-preview-wrap' ),
		playBtn = selector.querySelector( '.view-media' );

	if ( ! playBtn ) {
		return;
	}

	// Return if media loaded.
	if ( wrapper.classList.contains( 'media-loaded' ) ) {
		btyMediaAction( wrapper, action );

		return;
	}

	// Play current video.
	btyMediaAction( wrapper, action );

	if ( selector.hasAttribute( 'data-model' ) ) {
		return;
	}

	let template = selector.querySelector( 'template' ),
		mediaDiv = wrapper.querySelector( '.media-content' );

	if ( ! mediaDiv ) {
		wrapper.classList.add( 'media-loaded' );

		if ( template ) {
			wrapper.insertAdjacentHTML( 'beforeend', '<div class="media-content">' + template.innerHTML + '</div>' );
		}
	}

	// Remove model after loaded, inside <template> tag.
	if ( template ) {
		template.remove();
	}
}

// Load media on desktop.
function btyMediaDesktop( doc = document ) {
	let selectors = doc.querySelectorAll( '.main-item' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			if ( el.hasAttribute( 'data-model' ) ) {
				return;
			}

			el.addEventListener(
				'click',
				function() {
					btyLoadMedia( el, 'play' );
				}
			);
		}
	);
}

// Scroll to top.
function btyScrollToTop() {
	let myButton = document.getElementById( 'btnScrollToTop' );

	if ( ! myButton ) {
		return;
	}

	window.onscroll = function() {
		// Display after 400px height.
		if ( window.pageYOffset >= 400 ) {
			myButton.style.display = 'block';
		} else {
			myButton.style.display = 'none';
		}
	}

	// Onclick function.
	myButton.addEventListener(
		'click',
		function() {
			window.scrollTo(
				{
					top: 0,
					left: 0,
					behavior: "smooth"
				}
			);
		}
	);
}

// Open localization form.
function btyToggleLocalization() {
	let toggles = document.querySelectorAll( '.localization-selector' ),
		form    = document.querySelector( '.localization-form-wrapper' );

	if ( ! toggles.length || ! form ) {
		return;
	}

	// Toggle localization form.
	toggles.forEach(
		function ( el ) {
			el.onclick = function ( e ) {
				e.preventDefault();

				document.documentElement.classList.add( 'localization-form-open' );

				btyClosePopup( 'localization-form-open', form );
				let closeButton = form.querySelector( '.close-button' );
				if ( closeButton ) {
					setTimeout(
						function() {
							closeButton.focus();
						},
						400
					);
				}

			}
		}
	);

}

function btySubmitLocalization( doc = document ) {
	let forms = doc.querySelectorAll( '.localization-form' );
	if ( ! forms.length ) {
		return;
	}

	forms.forEach(
		function( form ) {
			let select = form.querySelectorAll( 'select' );
			if ( ! select.length ) {
				return;
			}

			select.forEach(
				function( el ) {
					el.addEventListener(
						'change',
						function() {
							form.submit();
						}
					);
				}
			);
		}
	);
}

class BtyDeliveryWidgetSlot extends HTMLElement {
	connectedCallback() {
		if ( this.initialized ) {
			return;
		}

		this.initialized = true;
		this.item = this.closest( '[data-delivery-widget-item]' );
		this.moveWidget();

		this.observer = new MutationObserver( () => this.moveWidget() );
		this.observer.observe( document.body, { childList: true, subtree: true } );
	}

	disconnectedCallback() {
		if ( this.observer ) {
			this.observer.disconnect();
		}

		this.observer = null;
		this.initialized = false;
	}

	prepareMessage( widget ) {
		let messages = Array.from( widget.querySelectorAll( '.msg__container p' ) );
		let message = messages.find( element => element.textContent.trim() !== '' );

		messages.forEach(
			element => {
				if ( element.textContent.trim() === '' && ! element.querySelector( 'svg' ) ) {
					element.hidden = true;
				}
			}
		);

		if ( ! message || message.querySelector( '.product-delivery-information__app-message-content' ) ) {
			return;
		}

		let icon = message.querySelector( 'svg' );
		let content = document.createElement( 'span' );
		content.className = 'product-delivery-information__app-message-content';

		Array.from( message.childNodes ).forEach(
			node => {
				if ( node !== icon ) {
					content.appendChild( node );
				}
			}
		);

		message.replaceChildren();
		message.classList.add( 'product-delivery-information__app-message' );

		if ( icon ) {
			message.appendChild( icon );
		}

		message.appendChild( content );
	}

	moveWidget() {
		let widget = Array.from(
			document.querySelectorAll( '.delivery-widget__theme .delivery-widget__container' )
		).find( element => ! this.contains( element ) );

		if ( ! widget ) {
			return;
		}

		let sourceBlock = widget.closest( '.summary-item.app-block' );
		this.prepareMessage( widget );
		this.replaceChildren( widget );

		if ( this.item ) {
			this.item.hidden = false;
		}

		if ( sourceBlock ) {
			sourceBlock.hidden = true;
		}
	}
}

customElements.define( 'bty-delivery-widget-slot', BtyDeliveryWidgetSlot );

class BtyDeliveryEstimate extends HTMLElement {
	connectedCallback() {
		if ( this.initialized ) {
			return;
		}

		this.initialized       = true;
		this.timeZone          = this.dataset.timeZone || 'Europe/London';
		this.cutoffHour        = Number.parseInt( this.dataset.cutoffHour, 10 ) || 0;
		this.cutoffMinute      = Number.parseInt( this.dataset.cutoffMinute, 10 ) || 0;
		this.deliveryDays      = Math.max( 1, Number.parseInt( this.dataset.deliveryDays, 10 ) || 1 );
		this.skipWeekends      = this.dataset.skipWeekends !== 'false';
		this.showCountdown     = this.dataset.showCountdown !== 'false';
		this.dateElement       = this.querySelector( '[data-delivery-date]' );
		this.countdownElement  = this.querySelector( '[data-delivery-countdown]' );
		this.countdownValue    = this.querySelector( '[data-delivery-countdown-value]' );
		this.excludedDates     = new Set(
			( this.dataset.excludedDates || '' )
				.split( /[,;\n]+/ )
				.map( date => date.trim() )
				.filter( date => /^\d{4}-\d{2}-\d{2}$/.test( date ) )
		);

		let documentLocale = document.documentElement.lang || 'en-GB';
		this.locale = /^en(?:-|$)/i.test( documentLocale ) ? 'en-GB' : documentLocale;

		this.update();
		this.timer = window.setInterval( () => this.update(), 30000 );
	}

	disconnectedCallback() {
		if ( this.timer ) {
			window.clearInterval( this.timer );
		}

		this.timer       = null;
		this.initialized = false;
	}

	getZonedParts( date ) {
		let values = {};
		let formatter = new Intl.DateTimeFormat(
			'en-GB-u-nu-latn',
			{
				timeZone: this.timeZone,
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hourCycle: 'h23'
			}
		);

		formatter.formatToParts( date ).forEach(
			part => {
				if ( part.type !== 'literal' ) {
					values[part.type] = Number.parseInt( part.value, 10 );
				}
			}
		);

		return values;
	}

	getDateKey( date ) {
		return [
			date.getUTCFullYear(),
			String( date.getUTCMonth() + 1 ).padStart( 2, '0' ),
			String( date.getUTCDate() ).padStart( 2, '0' )
		].join( '-' );
	}

	isDeliveryDay( date ) {
		let day = date.getUTCDay();

		if ( this.skipWeekends && ( day === 0 || day === 6 ) ) {
			return false;
		}

		return ! this.excludedDates.has( this.getDateKey( date ) );
	}

	moveToNextDeliveryDay( date ) {
		let nextDate = new Date( date.getTime() );

		do {
			nextDate.setUTCDate( nextDate.getUTCDate() + 1 );
		} while ( ! this.isDeliveryDay( nextDate ) );

		return nextDate;
	}

	addDeliveryDays( date, numberOfDays ) {
		let result    = new Date( date.getTime() );
		let daysAdded = 0;

		while ( daysAdded < numberOfDays ) {
			result.setUTCDate( result.getUTCDate() + 1 );

			if ( this.isDeliveryDay( result ) ) {
				daysAdded++;
			}
		}

		return result;
	}

	getTimeZoneOffset( date ) {
		let parts = this.getZonedParts( date );
		let zonedTimeAsUtc = Date.UTC(
			parts.year,
			parts.month - 1,
			parts.day,
			parts.hour,
			parts.minute,
			parts.second
		);
		let timestampWithoutMilliseconds = Math.floor( date.getTime() / 1000 ) * 1000;

		return zonedTimeAsUtc - timestampWithoutMilliseconds;
	}

	getCutoffTimestamp( date ) {
		let utcGuess = Date.UTC(
			date.getUTCFullYear(),
			date.getUTCMonth(),
			date.getUTCDate(),
			this.cutoffHour,
			this.cutoffMinute
		);
		let firstOffset  = this.getTimeZoneOffset( new Date( utcGuess ) );
		let timestamp    = utcGuess - firstOffset;
		let secondOffset = this.getTimeZoneOffset( new Date( timestamp ) );

		if ( firstOffset !== secondOffset ) {
			timestamp = utcGuess - secondOffset;
		}

		return timestamp;
	}

	formatCountdown( milliseconds ) {
		let totalMinutes = Math.max( 0, Math.ceil( milliseconds / 60000 ) );
		let days         = Math.floor( totalMinutes / 1440 );
		let hours        = Math.floor( ( totalMinutes % 1440 ) / 60 );
		let minutes      = totalMinutes % 60;
		let values       = [];

		if ( days > 0 ) {
			values.push( `${ days }d` );
		}

		values.push( `${ hours }h` );
		values.push( `${ minutes }m` );

		return values.join( ' ' );
	}

	update() {
		let now        = new Date();
		let localParts = this.getZonedParts( now );
		let today      = new Date( Date.UTC( localParts.year, localParts.month - 1, localParts.day ) );
		let afterCutoff = localParts.hour > this.cutoffHour ||
			( localParts.hour === this.cutoffHour && localParts.minute >= this.cutoffMinute );
		let processingDay = new Date( today.getTime() );

		if ( ! this.isDeliveryDay( processingDay ) || afterCutoff ) {
			processingDay = this.moveToNextDeliveryDay( processingDay );
		}

		let deliveryDate = this.addDeliveryDays( processingDay, this.deliveryDays );

		if ( this.dateElement ) {
			let formatter = new Intl.DateTimeFormat(
				this.locale,
				{
					timeZone: 'UTC',
					weekday: 'long',
					day: 'numeric',
					month: 'long'
				}
			);

			this.dateElement.textContent = formatter.format( deliveryDate );
			this.dateElement.dateTime    = this.getDateKey( deliveryDate );
		}

		if ( this.showCountdown && this.countdownElement && this.countdownValue ) {
			let cutoffDay = new Date( today.getTime() );

			if ( ! this.isDeliveryDay( cutoffDay ) || afterCutoff ) {
				cutoffDay = this.moveToNextDeliveryDay( cutoffDay );
			}

			this.countdownValue.textContent = this.formatCountdown( this.getCutoffTimestamp( cutoffDay ) - now.getTime() );
			this.countdownElement.hidden = false;
		}
	}
}

customElements.define( 'bty-delivery-estimate', BtyDeliveryEstimate );

// Popup focus.
function btyTrapFocus( container, firstFocusableElement ) {
	const focusableElements = container.querySelectorAll(
		'a[href], button:not([disabled]), input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
	);

	const firstElement = firstFocusableElement || focusableElements[0];
	const lastElement  = focusableElements[focusableElements.length - 1];

	function handleKeyDown(e) {
		if (e.key === 'Tab') {
			if (e.shiftKey) {
				if (document.activeElement === firstElement) {
					e.preventDefault();
					lastElement.focus();
				}
			} else {
				if (document.activeElement === lastElement) {
					e.preventDefault();
					firstElement.focus();
				}
			}
		}
	}

	container.addEventListener( 'keydown', handleKeyDown );
}

// DOM Loaded.
document.addEventListener(
	'DOMContentLoaded',
	function() {
		btyAccordionHover();
		btyScrollBar();
		btyNewsletterPopup();
		btyAgeverificationPopup();
		btyToggleDetails();
		btyHoverMediaVideo();
		btyCollectionSticky();
		btyAnimationImageLoad();
		btyAnimationCollageLoad();
		btyAccountPopup();
		btyCountdownTime();
		btyNavMenu();
		btyCookiesBar();
		btyAccordionHandle();
		btyToggleDropdown();
		btyVideo();
		btyBackgroundVideo();
		btyAddress();
		btyScrollAnimationTrigger();
		btyHeaderSticky();
		btyMediaDesktop();
		btyScrollToTop();
		btyToggleNavMenu();
		btyToggleLocalization();
		btySubmitLocalization();
		btyFooterAccordion();
		btyAddElementClass();

		window.addEventListener(
			'resize',
			function() {
				btyHeaderSticky();
				btyFooterAccordion();
				btyAddElementClass();
				btySplitSlider();
				btyMediaDesktop();
			}
		);

		window.addEventListener(
			'scroll',
			function() {
				btyHeaderSticky();
				btyScrollingDetect();
				btyAnimationImageLoad();
				btyAnimationCollageLoad();
			}
		);
	}
);

// Design mode event.
document.addEventListener(
	'shopify:section:load',
	function( e ) {
		let section = e.target;

		btySplitSlider( section );
		btyAccordionHover( section );
		btyAnimationImageLoad( section );
		btyAnimationCollageLoad( section );
		btyCountdownTime( section );
		btyProductTabs( section );
		btyAccordionHandle( section );
		btyToggleDropdown( section );
		btyVideo( section );
		btyBackgroundVideo( section );
		btyAddress( section );
		btyProductVariants( section );
		btyProductPopup( section );
		btyProductShare( section );
		btyCollectionSticky( section );
		btyQuantityButton( section );
		btyProductPurchaseControls( section );
		btyBackInStockButtons( section );
		btyScrollAnimationTrigger( section, true );
		btyMinicartRecommendations( section );
		btyNewsletterPopup( section );
		btyAgeverificationPopup( section );
		btySideCartPopupOuter( section );
		btyFeaturedProductSlider( section );
		btyToggleNavMenu( section );
		btyToggleLocalization( section );
		btySubmitLocalization( section );
		btyQuickView();
		btyQuickViewVariants();
		btyFooterAccordion();
		btyAddElementClass();
		setupThumbProgress( section );

		console.log( 'Section load.' );
	}
);
document.addEventListener(
	'shopify:section:select',
	function( e ) {
		let section = e.target;

		btySplitSlider( section );
		btyAccordionHover( section );
		btyQuickSearch();
		btyCookiesBar( section );
		btyNewsletterPopup( section );
		btyAgeverificationPopup( section );
		btyAnimationImageLoad( section );
		btyAnimationCollageLoad( section );
		btyNavMenu( section, e );
		btyToggleDropdown( section );
		btyProductTabs( section );
		btyCountdownTime( section );
		btyAccordionHandle( section );
		btyVideo( section );
		btyBackgroundVideo( section );
		btyAddress( section );
		btyProductVariants( section );
		btyProductPopup( section );
		btyProductShare( section );
		btyAccountPopup( section );
		btyQuickAdd( section );
		btyScrollBar( section );
		btyHoverMediaVideo( section );
		btySwatch( section );
		btyCollectionSticky( section );
		btyCheckInventoryOnLoad( section );
		btyAddToCart( section );
		btyAddMultiProductToCart( section );
		btyQuantityButton( section );
		btyProductPurchaseControls( section );
		btyBackInStockButtons( section );
		btyMinicartRecommendations( section );
		btySideCartPopupOuter( section );
		btyFeaturedProductSlider( section );
		btyShortDescription( section );
		btyToggleNavMenu( section );
		btyToggleLocalization( section );
		btySubmitLocalization( section );
		setupThumbProgress( section );
		btyQuickView();
		btyQuickViewVariants();
		btyFooterAccordion();
		btyAddElementClass();
		console.log( 'Section select.' );
	}
);
document.addEventListener(
	'shopify:block:select',
	function( e ) {
		console.log( 'Block select.' );

		let section = document.getElementById( 'shopify-section-' + e.detail.sectionId );
		if ( ! section ) {
			return;
		}

		btySplitSlider( section );
		btyAccordionHover( section );
		btyNewsletterPopup( section );
		btyAgeverificationPopup( section );
		btyAnimationImageLoad( section );
		btyAnimationCollageLoad( section );
		btyProductVariants( section );
		btyProductTabs( section, e );
		btyCollectionSticky( section );
		btyMinicartRecommendations( section );
		btySideCartPopupOuter( section );
		btyShortDescription( section );
		btyQuickView( section );
		btyQuickViewVariants();
		btyFooterAccordion();
		btyAddElementClass();
	}
);
document.addEventListener(
	'shopify:section:reorder',
	function( e ) {
		let section = e.target;

		btyScrollAnimationTrigger( section, true );

		console.log( 'Section reorder.' );
	}
);
